import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcb65448"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = { class: "vrt-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Virtual Red Tag", -1))
const _hoisted_4 = { class: "vrt-options" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vrt-options-label" }, "Choose an option", -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "vrt-option-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgRedTag = _resolveComponent("SvgRedTag")!
  const _component_SvgChevronRight = _resolveComponent("SvgChevronRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SvgRedTag, { class: "vrt-header-icon" }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: option.name,
          class: "vrt-option",
          type: "button",
          onClick: ($event: any) => (_ctx.selectOption(option.name))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), {
            class: "vrt-option-icon",
            color: "#312F2A"
          })),
          _createElementVNode("span", _hoisted_7, _toDisplayString(option.text), 1),
          _createVNode(_component_SvgChevronRight, { class: "vrt-option-chevron" })
        ], 8, _hoisted_6))
      }), 128))
    ])
  ]))
}